import { useMutation, useQueryClient } from 'react-query'
import { User, UserSearchResult } from '@dc-shared-web/hooks/api/user'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import {
  updateUserProfile,
  UpdateUserProfileParams,
} from '@dc-shared-web/hooks/api/user/updateUserProfile'

export const useUpdateUserProfile = () => {
  const svcCrunchesApiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()

  return useMutation(
    (params: UpdateUserProfileParams) => {
      return updateUserProfile(svcCrunchesApiClient, params)
    },
    {
      onSuccess: async (_, params: UpdateUserProfileParams) => {
        await queryClient.invalidateQueries<User>(`user-${params.uuid}`)
        await queryClient.invalidateQueries<UserSearchResult>({
          queryKey: ['searchUser'],
          refetchPage: (page) => {
            return Boolean(page.data.find((e) => e.uuid === params.uuid))
          },
        })
      },
    }
  )
}
